import { pgEnum } from 'drizzle-orm/pg-core'

export const ReadWriteDeleteEnum = pgEnum('read_write_delete_enum', ['READ', 'WRITE', 'DELETE'])
export type ReadWriteDelete = (typeof ReadWriteDeleteEnum.enumValues)[number]

export const ProgressStatusEnum = pgEnum('progress_status_enum', ['NOT_STARTED', 'IN_PROGRESS', 'COMPLETED', 'FAILED'])
export type ProgressStatus = (typeof ProgressStatusEnum.enumValues)[number]

export const GenderEnum = pgEnum('gender_enum', ['MALE', 'FEMALE'])
export type Gender = (typeof GenderEnum.enumValues)[number]

export const BookContributorTypeEnum = pgEnum('book_contributor_type_enum', ['ILLUSTRATOR', 'AUTHOR'])
export type BookContributorType = (typeof BookContributorTypeEnum.enumValues)[number]

/**
 * `COLLECTION` is a user-authored `MyBookCollection`; `BOOK_COLLECTION` is a curated
 * catalogue `BookCollection`. They are separate values because they live in different
 * tables and open different routes for the recipient.
 */
export const ShareEntityTypeEnum = pgEnum('share_entity_type_enum', [
  'BOOK',
  'COLLECTION',
  'BOOK_COLLECTION',
  'CHALLENGE',
  'EXERCISE',
])
export type ShareEntityType = (typeof ShareEntityTypeEnum.enumValues)[number]

/**
 * `CONNECT` carries the Sambung Sekolah-Rumah lifecycle. It is a category rather than a bare type so
 * the /pesan feed can give it its own filter chip alongside the existing ones.
 *
 * `PREMIUM` is the "Akses Premium" chip the designs reserved: a child asking the adults responsible
 * for them to open premium content. Separate from `SYSTEM` because it is a request someone has to
 * act on, and an adult filtering for those should not have to read past every system notice.
 */
export const NotificationCategoryEnum = pgEnum('notification_category_enum', [
  'SHARE',
  'ASSIGNMENT',
  'SYSTEM',
  'CONNECT',
  'PREMIUM',
])
export type NotificationCategory = (typeof NotificationCategoryEnum.enumValues)[number]

export const NotificationAudienceEnum = pgEnum('notification_audience_enum', ['RECIPIENT', 'ACTOR'])
export type NotificationAudience = (typeof NotificationAudienceEnum.enumValues)[number]

export const NotificationChannelEnum = pgEnum('notification_channel_enum', [
  'IN_APP',
  'EMAIL',
  'WEB_PUSH',
  'MOBILE_PUSH',
])
export type NotificationChannel = (typeof NotificationChannelEnum.enumValues)[number]

export const NotificationDeliveryStatusEnum = pgEnum('notification_delivery_status_enum', [
  'PENDING',
  'SENT',
  'FAILED',
  'SKIPPED',
])
export type NotificationDeliveryStatus = (typeof NotificationDeliveryStatusEnum.enumValues)[number]
